
export function initDcImageGallery(wrapper = document) {
    for(const gallery of wrapper.querySelectorAll('.dcImageGallery')) {
        const items = gallery.querySelectorAll('.dcImageGalleryItem');

        if(items.length > 4) {
            items[3].classList.add("dcImageGalleryItem--counterWrapper");
            const counter = document.createElement('span');
            counter.classList.add("dcImageGalleryItem__counter");
            counter.innerText = `+${items.length - 4}`;
            items[3].appendChild(counter);
        }
    }
}